import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { Container, Heading, Tabs, TabList, TabPanels, Tab, TabPanel, Alert, AlertIcon, Box } from "@chakra-ui/react";
import {
  Buildings,
  Image,
  ChatCircle,
  Users,
  ListChecks,
  Robot,
  Brain,
  Database,
  ArchiveBox, // Added for Data Exporter
  Clock, // Added for Timeline Manager
  Flag,
} from '@phosphor-icons/react';

import SiteManager from '../components/admin/SiteManager';
import MediaManager from '../components/admin/MediaManager';
import CommentManager from '../components/admin/CommentManager';
import UserManager from '../components/admin/UserManager';
import FeatureOptionsManager from '../components/admin/FeatureOptionsManager';
import AutoDetectMappingManager from '../components/admin/AutoDetectMappingManager';
import ModelTrainingManager from '../components/admin/ModelTrainingManager';
import MigrationTool from '../components/admin/MigrationTool';
import DataExporter from '../components/admin/DataExporter'; // Import DataExporter
import TimelineManager from '../components/admin/TimelineManagerSync'; // Import TimelineManager (With real sync functionality)
import AdminFlags from './AdminFlags';

export default function Admin() {
  const { user } = useSelector(state => state.auth);

  // Double-check admin status
  if (!user || user.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return (
    <Container maxW="container.xl" py={8}>
      <Box mb={8}>
        <Heading as="h1" size={{ base: 'lg', md: 'xl' }}>Admin Dashboard</Heading> {/* Responsive size */}
      </Box>

      <Alert status="info" mb={6}>
        <AlertIcon />
        Welcome to the admin dashboard. Here you can manage all site content,
        media, comments, and user permissions.
      </Alert>

      <Tabs>
        <TabList mb={4} overflowX="auto" flexWrap="nowrap">
          <Tab fontSize="sm"><Box mr={1}><Buildings size={14} /></Box>Sites</Tab>
          <Tab fontSize="sm"><Box mr={1}><Image size={14} /></Box>Media</Tab>
          <Tab fontSize="sm"><Box mr={1}><ChatCircle size={14} /></Box>Comments</Tab>
          <Tab fontSize="sm"><Box mr={1}><Users size={14} /></Box>Users</Tab>
          <Tab fontSize="sm"><Box mr={1}><ListChecks size={14} /></Box>Features</Tab>
          <Tab fontSize="sm"><Box mr={1}><Robot size={14} /></Box>Auto-detect</Tab>
          <Tab fontSize="sm"><Box mr={1}><Brain size={14} /></Box>Training</Tab>
          <Tab fontSize="sm"><Box mr={1}><Database size={14} /></Box>Migration</Tab>
          <Tab fontSize="sm"><Box mr={1}><ArchiveBox size={14} /></Box>Export</Tab>
          <Tab fontSize="sm"><Box mr={1}><Clock size={14} /></Box>Timeline</Tab>
          <Tab fontSize="sm"><Box mr={1}><Flag size={14} /></Box>Flags</Tab>
        </TabList>

        <TabPanels>
          <TabPanel>
            <SiteManager />
          </TabPanel>

          <TabPanel>
            <MediaManager />
          </TabPanel>

          <TabPanel>
            <CommentManager />
          </TabPanel>

          <TabPanel>
            <UserManager />
          </TabPanel>

          <TabPanel>
            <FeatureOptionsManager />
          </TabPanel>

          <TabPanel>
            <AutoDetectMappingManager />
          </TabPanel>

          <TabPanel>
            <ModelTrainingManager />
          </TabPanel>
          
          <TabPanel>
            <MigrationTool />
          </TabPanel>

          <TabPanel> {/* New TabPanel */}
            <DataExporter />
          </TabPanel>

          <TabPanel> {/* Timeline TabPanel */}
            <TimelineManager />
          </TabPanel>
          <TabPanel>
            <AdminFlags />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Container>
  );
}
